// get delivery
export const GET_DELIVERY = "GET_DELIVERY";

// create
export const CREATE_DELIVERY = "CREATE_DELIVERY";

// update
export const UPDATE_DELIVERY = "UPDATE_DELIVERY";

// delete
export const DELETE_DELIVERY = "DELETE_DELIVERY";

// toggle
export const TOGGLE_DELIVERY = "TOGGLE_DELIVERY";